// React
import React from 'react';

// Shared
import items from '../../../data/main-nav.json';

// Third party
import PropTypes from 'prop-types';

// Styles
import styles from './MainNav.module.scss';

// Material UI
import { List } from '@material-ui/core';

// Components
import MainNavItem from '../MainNavItem/MainNavItem';

// This component
export default function MainNav({ isDrawerMenu, closeDrawer }) {
  // JSX
  return (
    <List className={styles.list}>
      {items &&
        items.map((item, i) => {
          return (
            <MainNavItem
              key={i}
              label={item.label}
              to={item.to}
              logout={item.logout}
              isDrawerMenu={isDrawerMenu}
              closeDrawer={closeDrawer}
              items={item.items}
            />
          );
        })}
    </List>
  );
}

// Properties
MainNav.propTypes = {
  isDrawerMenu: PropTypes.bool.isRequired,
  closeDrawer: PropTypes.func.isRequired
};
